import React from 'react'
import { Table } from 'react-bootstrap'
import DataTables from '../../Main/DataTable/DataTables';

const UserWithdrawableTransaction = ({ withdrawableTransaction }) => {

    const columns = [

        { name: 'Email', selector: row => row?.user_email },
        { name: 'Account Title', selector: row => row?.account_title },
        { name: 'Account Number', selector: row => row?.account_number },
        { name: 'Bank Name', selector: row => row.bank_name },
        { name: 'Amount', selector: row => row.amount },
        { name: 'Status', selector: row => row.status },
        { name: 'Date', selector: row => row.created_at },
    ];

    return (
        <>

            <DataTables filter={false} columns={columns} data={withdrawableTransaction} />

        </>
    )
}

export default UserWithdrawableTransaction